import { createContext, useState } from 'react';
import api from 'services/api';

export const DocumentosContext = createContext();

export const DocumentosProvider = ({ children }) => {
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);
  const [getLoading, setGetLoading] = useState(false);
  const [documento, setDocumento] = useState(null);
  const [documentoItem, setDocumentoItem] = useState(null);
  const [documentoItens, setDocumentoItens] = useState([]);
  const [documentoOrigens, setDocumentoOrigens] = useState([]);
  const [documentoVinculos, setDocumentoVinculos] = useState([]);

  const getDocumento = async (id) => {
    try {
      setGetLoading(true);
      setDocumento(null);
      const { data } = await api.get(`/Cadastros/Documento/${id}`, {
        params: {
          Itens: true,
          Registros: true,
          Entrada: true,
          Financeiro: true,
          Transportes: true,
          NFe: true,
          Totais: true,
          Moedas: true,
          RequisicaoCompras: true,
          PedidoCompras: true,
          CotacaoCompras: true,
        },
      });
      setDocumento(data);
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postDocumento = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      const { data: res } = await api.post('/Cadastros/Documento', data);
      if (cb) {
        cb(res);
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const postDocumentos = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Documento/Multiple', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const deleteDocumento = async ({ id, cb }) => {
    try {
      setDeleteLoading(true);
      await api.delete(`/Cadastros/Documento/${id}`);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setDeleteLoading(false);
    }
  };

  const postAnexo = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Documento/Registro/Anexo', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const deleteAnexo = async ({ id, cb }) => {
    try {
      setDeleteLoading(true);
      await api.delete(`/Cadastros/Documento/Registro/Anexo/${id}`);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setDeleteLoading(false);
    }
  };

  const getDocumentoItem = async (id) => {
    try {
      setGetLoading(true);
      setDocumentoItem(null);
      const { data } = await api.get(`/Cadastros/Documento/Item/${id}`, {
        params: {
          Estrutura: true,
          Processo: true,
          Imposto: true,
          Mc: true,
          Vinculo: true,
          Variacao: true,
          Movimentos: true,
        },
      });
      setDocumentoItem(data);
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postDocumentoItemImposto = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Documento/Item/ImpostoReset', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const postDocumentoItemCfo = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Documento/Item/CfoReset', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const getDocumentoVinculos = async ({ params, cb = null }) => {
    try {
      setGetLoading(true);
      setDocumentoVinculos([]);
      const { data } = await api.get(`/Cadastros/Documento/Vinculos`, {
        params,
      });
      setDocumentoVinculos(data);
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const getDocumentoOrigens = async ({ params, cb = null }) => {
    try {
      setGetLoading(true);
      setDocumentoOrigens([]);
      const { data } = await api.get(`/Cadastros/Documento/Origens`, {
        params,
      });
      setDocumentoOrigens(data);
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const getDocumentoItens = async (id) => {
    try {
      setGetLoading(true);
      setDocumentoItens([]);
      const { data } = await api.get(`/Cadastros/Documento/Itens/${id}`, {
        params: {
          Produto: true,
          Imposto: true,
          Variacao: true,
        },
      });
      setDocumentoItens(data);
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const deleteDocumentoItemVinculo = async ({ params, cb = null }) => {
    try {
      setDeleteLoading(true);
      await api.delete(`/Cadastros/Documento/Item/Vinculo`, {
        params,
      });
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setDeleteLoading(false);
    }
  };

  const getFormacaoPreco = async ({ id, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get(`/Suprimentos/Compra/FormacaoPreco/${id}`);
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <DocumentosContext.Provider
      value={{
        deleteLoading,
        postLoading,
        getLoading,
        documento,
        documentoItem,
        documentoItens,
        documentoVinculos,
        documentoOrigens,
        deleteDocumento,
        postDocumentos,
        postDocumento,
        getDocumento,
        deleteAnexo,
        postAnexo,
        postDocumentoItemImposto,
        postDocumentoItemCfo,
        getDocumentoVinculos,
        getDocumentoOrigens,
        getDocumentoItens,
        getDocumentoItem,
        deleteDocumentoItemVinculo,
        getFormacaoPreco,
      }}
    >
      {children}
    </DocumentosContext.Provider>
  );
};
